import React, { useState, useEffect, useCallback } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import config from '../../../config/config';

export function ManualBooking() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();

  // URL param ko priority taake refresh par crash na ho
  const animalId = id || state?.id || state?.animal?.id;
  console.log(animalId);

  const [loading, setLoading] = useState(true);
  const [pricePerShare, setPricePerShare] = useState(0);

  const [formData, setFormData] = useState({
    shareholders: [{ firstName: '', lastName: '', isFisabilillah: false }],
    customer_name: '',
    phone: '',
    shares: '1',
    address: '',
    email: '',
    payment_method: 'Cash',
    bank_name: '',
    cheque_no: '',
    transaction_id: '',
    received_payment: 0,
    total_price: 0,
    remaining_balance: 0,
    animal_id: animalId || '',
    category: '',
    slaughtering_day: '',
    animal_no: '',
    type: '',
    remaining_shares: 0
  });

  const fetchDetails = useCallback(async () => {
    if (!animalId) return;
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${config.baseUrl}/api/hold/hold-booking/${animalId}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.ok) {
        const result = await response.json();
        const data = result.animal || result;
        const price = parseFloat(data.price_per_share || data.price || 0);
        const available = parseInt(data.remaining_shares || data.available_shares || 0);

        setPricePerShare(price);
        setFormData(prev => {
          const currentShares = parseInt(prev.shares) || 1;
          const newTotal = price * currentShares;
          return {
            ...prev,
            animal_id: data.id,
            category: data.category,
            slaughtering_day: data.slaughtering_day,
            type: data.type,
            animal_no: data.animal_no || data.animal_number,
            email: localStorage.getItem('userEmail') || '',
            total_price: newTotal,
            remaining_balance: newTotal - (parseFloat(prev.received_payment) || 0),
            remaining_shares: available,
            cat_id: data.cat_id,
            subcat_id: data.subcat_id
          };
        });
      }
    } catch (error) {
      console.error("Fetch Error:", error);
    } finally {
      setLoading(false);
    }
  }, [animalId]);

  useEffect(() => {
    if (!animalId) {
      alert("No Animal ID found!");
      navigate(-1);
      return;
    }
    fetchDetails();
  }, [animalId, navigate, fetchDetails]);

  const handlePaymentInput = (val) => {
    const received = parseFloat(val) || 0;
    setFormData(prev => ({
      ...prev,
      received_payment: val,
      remaining_balance: prev.total_price - received
    }));
  };

  const handleShareChange = (num) => {
    const newCount = parseInt(num);
    const newTotal = newCount * pricePerShare;

    setFormData(prev => {
      let updatedShareholders = [...prev.shareholders];
      if (newCount > updatedShareholders.length) {
        for (let i = updatedShareholders.length; i < newCount; i++) {
          updatedShareholders.push({ firstName: '', lastName: '', isFisabilillah: false });
        }
      } else {
        updatedShareholders = updatedShareholders.slice(0, newCount);
      }

      return {
        ...prev,
        shares: num,
        total_price: newTotal,
        remaining_balance: newTotal - (parseFloat(prev.received_payment) || 0),
        shareholders: updatedShareholders
      };
    });
  };

  const handleShareholderChange = (index, field, value) => {
    setFormData(prev => {
      const updatedShareholders = [...prev.shareholders];
      // Fixed: Object ki copy banai hai taake state direct mutate na ho
      updatedShareholders[index] = {
        ...updatedShareholders[index],
        [field]: value
      };

      // Agar Fisabilillah select ho to name clear kar dein
      if (field === 'isFisabilillah' && value === true) {
        updatedShareholders[index].firstName = '';
        updatedShareholders[index].lastName = '';
      }

      return { ...prev, shareholders: updatedShareholders };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (parseFloat(formData.received_payment) < 0) {
      alert("Received payment cannot be negative");
      return;
    }

    const generatedCustomerId = `QRB${Math.floor(Math.random() * 100000)}`;
    const payload = {
      ...formData,
      customer_id: generatedCustomerId,
      booking_date: new Date().toISOString(), // Standard format for backend
    };

    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${config.baseUrl}/api/hold/share-booking`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(payload)
      });

      if (response.ok) {
        alert('Booking Confirmed Successfully!');
        navigate(`/moderator/booking/${generatedCustomerId}`, { state: { ...payload } });
      } else {
        const errorData = await response.json();
        alert(`Error: ${errorData.message || 'Submission failed'}`);
      }
    } catch (error) {
      alert('Network error, please try again.');
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="text-xl font-bold text-blue-600 animate-pulse">Loading Animal Data...</div>
      </div>
    );
  }

  const isLargeAnimal = ['cow', 'camel'].includes(formData.type?.toLowerCase());

  return (
    <div className="min-h-screen bg-gray-100 py-8 px-4">
      <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-xl overflow-hidden border border-gray-200">

        {/* Header */}
        <div className="bg-gradient-to-r from-blue-700 to-blue-900 p-6 text-white flex justify-between items-center">
          <div>
            <h2 className="text-2xl font-black uppercase tracking-tight">Manual Booking Registration</h2>
            <p className="text-blue-100 text-xs mt-1">Register customer shares for hold animals</p>
          </div>
          <div className="text-right">
            <span className="bg-white/20 backdrop-blur-md px-4 py-2 rounded-lg font-mono font-bold text-lg">
              TAG: #{formData.animal_no}
            </span>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="p-8 space-y-8">

          {/* 1. Customer Information */}
          <section>
            <div className="flex items-center gap-2 mb-4 border-b pb-2">
              <div className="w-2 h-6 bg-blue-600 rounded-full"></div>
              <h3 className="font-black text-gray-700 uppercase text-sm tracking-widest">Customer Information</h3>
            </div>
            <div className="grid grid-cols-2 gap-5">
              <div className="col-span-2 md:col-span-1">
                <label className="block text-[10px] font-bold mb-1 text-gray-500 uppercase">Customer Name</label>
                <input required type="text" className="w-full border-2 border-gray-100 rounded-lg p-3 focus:border-blue-500 outline-none bg-gray-50/50 transition-all"
                  value={formData.customer_name} onChange={(e) => setFormData({ ...formData, customer_name: e.target.value })} placeholder="Full Name" />
              </div>
              <div className="col-span-2 md:col-span-1">
                <label className="block text-[10px] font-bold mb-1 text-gray-500 uppercase">Phone Number</label>
                <input required type="text" className="w-full border-2 border-gray-100 rounded-lg p-3 focus:border-blue-500 outline-none bg-gray-50/50 transition-all"
                  value={formData.phone} onChange={(e) => setFormData({ ...formData, phone: e.target.value })} placeholder="03xx-xxxxxxx" />
              </div>
              <div className="col-span-2">
                <label className="block text-[10px] font-bold mb-1 text-gray-500 uppercase">Address</label>
                <input required type="text" className="w-full border-2 border-gray-100 rounded-lg p-3 focus:border-blue-500 outline-none bg-gray-50/50 transition-all"
                  value={formData.address} onChange={(e) => setFormData({ ...formData, address: e.target.value })} placeholder="Residential Address" />
              </div>
            </div>
          </section>

          {/* 2. Share Selection */}
          <section className="bg-blue-50/50 p-6 rounded-xl border border-blue-100">
            <div className="flex items-center justify-between">
              <div>
                <label className="block text-sm font-black text-blue-900 uppercase">Select Number of Shares</label>
                <p className="text-[10px] text-blue-600 font-bold">Available: {formData.remaining_shares} Shares</p>
              </div>
              <select className="w-48 border-2 border-blue-200 rounded-lg p-3 font-black text-blue-800 outline-none focus:border-blue-600 bg-white shadow-sm cursor-pointer"
                value={formData.shares} onChange={(e) => handleShareChange(e.target.value)}>
                {isLargeAnimal ? (
                  [...Array(formData.remaining_shares || 0)].map((_, i) => (
                    <option key={i + 1} value={i + 1}>{i + 1} {i === 0 ? 'Share' : 'Shares'}</option>
                  ))
                ) : (
                  <option value="1">Full Animal (1 Share)</option>
                )}
              </select>
            </div>
          </section>

          {/* 3. Shareholder Details */}
          <section className="space-y-6">
            <div className="flex items-center gap-2 mb-4 border-b pb-2">
              <div className="w-2 h-6 bg-blue-600 rounded-full"></div>
              <h3 className="font-black text-gray-700 uppercase text-sm tracking-widest">Shareholder Details</h3>
            </div>
            <div className="grid grid-cols-1 gap-6">
              {formData.shareholders.map((person, index) => (
                <div key={index} className="p-6 border-2 border-gray-50 rounded-2xl bg-white shadow-sm hover:border-blue-100 transition-all">
                  <div className="flex justify-between items-center mb-4">
                    <span className="text-[10px] font-black bg-blue-600 text-white px-3 py-1 rounded-full uppercase tracking-widest italic">Member {index + 1}</span>
                    <label className="flex items-center gap-2 cursor-pointer group">
                      <input type="checkbox" className="w-5 h-5 rounded-md border-gray-300 text-green-600 focus:ring-green-500 transition-all cursor-pointer"
                        checked={person.isFisabilillah} onChange={(e) => handleShareholderChange(index, 'isFisabilillah', e.target.checked)} />
                      <span className="text-xs font-black text-gray-500 group-hover:text-green-700 uppercase tracking-tighter">Fisabilillah</span>
                    </label>
                  </div>
                  <div className="grid grid-cols-2 gap-4">
                    <input required={!person.isFisabilillah} disabled={person.isFisabilillah} placeholder={person.isFisabilillah ? "Fisabilillah (Auto)" : "First Name"}
                      className={`w-full border-2 border-gray-100 rounded-lg p-3 outline-none focus:border-blue-400 ${person.isFisabilillah ? 'bg-gray-50 text-gray-400 italic font-bold' : 'bg-white font-semibold'}`}
                      value={person.isFisabilillah ? 'Fisabilillah' : person.firstName} onChange={(e) => handleShareholderChange(index, 'firstName', e.target.value)} />
                    <input required={!person.isFisabilillah} disabled={person.isFisabilillah} placeholder={person.isFisabilillah ? "---" : "Last Name"}
                      className={`w-full border-2 border-gray-100 rounded-lg p-3 outline-none focus:border-blue-400 ${person.isFisabilillah ? 'bg-gray-50 text-gray-400 italic' : 'bg-white font-semibold'}`}
                      value={person.isFisabilillah ? '' : person.lastName} onChange={(e) => handleShareholderChange(index, 'lastName', e.target.value)} />
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* 4. Payment & Billing */}
          <section className="bg-gray-50 p-6 rounded-2xl border-2 border-gray-100 shadow-inner">
            <div className="flex items-center gap-2 mb-6">
              <div className="w-2 h-6 bg-green-600 rounded-full"></div>
              <h3 className="font-black text-gray-700 uppercase text-sm tracking-widest">Payment & Billing</h3>
            </div>

            <div className="grid grid-cols-3 gap-4 mb-6">
              <div className="bg-white p-4 rounded-xl border border-gray-200 shadow-sm">
                <label className="block text-[10px] font-black text-blue-600 uppercase mb-1">Total Payable</label>
                <p className="text-xl font-black text-gray-800 tracking-tight">Rs. {formData.total_price}</p>
              </div>
              <div className="bg-white p-4 rounded-xl border border-green-200 shadow-sm">
                <label className="block text-[10px] font-black text-green-600 uppercase mb-1 tracking-tighter">Amount Received</label>
                <input required type="number" className="w-full text-xl font-black text-green-700 outline-none border-b-2 border-green-100 focus:border-green-500 p-0"
                  value={formData.received_payment} onChange={(e) => handlePaymentInput(e.target.value)} />
              </div>
              <div className={`p-4 rounded-xl border shadow-sm ${formData.remaining_balance > 0 ? 'bg-red-50 border-red-100' : 'bg-green-50 border-green-100'}`}>
                <label className="block text-[10px] font-black text-gray-500 uppercase mb-1">Balance</label>
                <p className={`text-xl font-black tracking-tight ${formData.remaining_balance > 0 ? 'text-red-600' : 'text-green-600'}`}>
                  Rs. {formData.remaining_balance}
                </p>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-6">
              <div className="col-span-2 md:col-span-1">
                <label className="block text-[10px] font-black text-gray-500 uppercase mb-2">Payment Mode</label>
                <div className="flex gap-2">
                  {['Cash', 'Cheque', 'Bank Transfer'].map(mode => (
                    <button key={mode} type="button"
                      onClick={() => setFormData({ ...formData, payment_method: mode })}
                      className={`flex-1 py-3 px-2 rounded-lg text-xs font-black transition-all ${formData.payment_method === mode ? 'bg-blue-600 text-white shadow-md scale-105' : 'bg-white text-gray-500 border border-gray-200 hover:bg-gray-100'}`}>
                      {mode}
                    </button>
                  ))}
                </div>
              </div>
              <div className="col-span-2 md:col-span-1">
                {formData.payment_method === 'Cheque' && (
                  <div className="grid grid-cols-2 gap-3 animate-in fade-in slide-in-from-top-2">
                    <input required className="w-full border-2 border-blue-100 rounded-lg p-2.5 text-sm font-bold outline-none focus:border-blue-500" placeholder="Bank Name"
                      value={formData.bank_name} onChange={(e) => setFormData({ ...formData, bank_name: e.target.value })} />
                    <input required className="w-full border-2 border-blue-100 rounded-lg p-2.5 text-sm font-bold outline-none focus:border-blue-500" placeholder="Cheque #"
                      value={formData.cheque_no} onChange={(e) => setFormData({ ...formData, cheque_no: e.target.value })} />
                  </div>
                )}
                {formData.payment_method === 'Bank Transfer' && (
                  <input required className="w-full border-2 border-blue-100 rounded-lg p-2.5 text-sm font-mono font-bold outline-none focus:border-blue-500 animate-in fade-in slide-in-from-top-2" placeholder="Transaction ID (TID)"
                    value={formData.transaction_id} onChange={(e) => setFormData({ ...formData, transaction_id: e.target.value })} />
                )}
              </div>
            </div>
          </section>

          {/* Footer Button */}
          <div className="pt-4">
            <button type="submit" className="w-full bg-gradient-to-r from-blue-600 to-blue-700 text-white py-4 rounded-2xl font-black text-xl hover:from-blue-700 hover:to-blue-800 transform active:scale-[0.98] transition-all uppercase tracking-widest shadow-lg">
              Confirm & Register Booking
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}